module.exports = __webpack_public_path__ + "img/network3.0ff1b6de.png";